export function getColorTone(happyValues, date) {
    if (!happyValues) return 'var(--tone0)'
    return happyValues[date] ? 'var(--tone' + happyValues[date]+ ')' : 'var(--tone0)'
}